import { orderBy } from "lodash";

export const sortGroupsAndDials = (data: User.Group[]): User.Group[] => {
  const groups = data.map((group) => {
    const dials = orderBy(group.dials, "order", "asc");
    return { ...group, dials };
  });
  return orderBy(groups, "order", "asc");
};
